import React, { Component } from "react";
import AntdRow, {RowProps} from 'antd/lib/row';
import 'antd/lib/row/style';

export default class Row extends Component<RowProps> {
    render() {
        return (
          <AntdRow {...this.props} />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/row/index.tsx